import { PdfSummary } from '../components/Asset/PdfSummary';
import { PdfAssetsList } from '../components/Asset/PdfAssetsList';
import { ReportPDFReponse } from 'queries/report/contract';
import PageWrapper from '../components/PageWrapper/PageWrapper';
import PdfPageTitle from '../components/PageTitle/PdfPageTitle';

type AssetProps = {
  data: ReportPDFReponse;
  date: string;
  category: string;
};

export const MainPage = ({ data, date, category }: AssetProps) => {
  return (
    <PageWrapper
      assetName={data.name}
      date={date}
      category={category}
      assetDescription={data.description}
    >
      <PdfSummary data={data} />
      <PdfPageTitle pageNumber={1} />
      <PdfAssetsList data={data} depth={2} />
    </PageWrapper>
  );
};
